import DownloadOutlined from "@mui/icons-material/DownloadOutlined";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { useMemo } from "react";
import { usePdfDownloadHook } from "../../../hooks/usePdfDownloadHook";

const CellRendererDownloadLoanApplication = (params) => {
  const data = params?.data;

  const filename = useMemo(() => {
    if (data?.firstName && data?.lastName) {
      return `${data.firstName}-${data.lastName}-loan-application.pdf`;
    }
    return "loan-application-form.pdf";
  }, [data]);

  const { downloadPDF, loading } = usePdfDownloadHook({
    formData: data,
    filename,
    type: "loan-application",
  });
  return (
    <Tooltip title="Download Loan Application PDF">
      <IconButton
        loading={loading}
        size="small"
        color="primary"
        onClick={downloadPDF}
        disabled={loading}
      >
        <DownloadOutlined className="thin-8" />
      </IconButton>
    </Tooltip>
  );
};

export default CellRendererDownloadLoanApplication;
